import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-date",
  "use": "icon-date-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-date\">\r\n  <path d=\"M736 112h-48V64a48 48 0 0 0-96 0v48H432V64a48 48 0 0 0-96 0v48h-48C182 112 96 198 96 304v432c0 106 86 192 192 192h448c106 0 192-86 192-192V304c0-106-86-192-192-192zM288 208h48v48a48 48 0 0 0 96 0v-48h160v48a48 48 0 0 0 96 0v-48h48c53 0 96 43 96 96v80H192v-80c0-53 43-96 96-96zM736 832H288c-53 0-96-43-96-96V480h640v256c0 53-43 96-96 96z\" />\r\n  <path d=\"M368 584h80v80h-80zM576 584h80v80h-80zM368 704h80v80h-80zM576 704h80v80h-80z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/date.svg
// module id = Ve8B
// module chunks = 78